import { useState } from "react";
import { T } from "react-translator-component";
import { Box, Typography } from "@mui/material";
import tab1 from "../../assets/images/tabs/tab1.png";
import tab2 from "../../assets/images/tabs/tab2.png";
import tab3 from "../../assets/images/tabs/tab3.png";
import tab4 from "../../assets/images/tabs/tab4.png";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { colors } from "../../common/colors";

interface Props {
  onChange(value: any): void;
}

const TabComponent = ({ onChange }: Props) => {
  // TODO: 「全て」以外はDBの内容を表示すべき
  // 対応するには、本番データの確認・UI仕様検討が必要
  const TAB_LIST = [
    {key: "All", name: T("all"), icon: tab1},
    {key: "Community", name: T("community"), icon: tab2},
    {key: "Event", name: T("event"), icon: tab3},
    {key: "Report", name: T("report"), icon: tab4},
  ]

  const [value, setValue] = useState<number>(0);
  const [selectTabKey, setSelectTabKey] = useState<string>("");

  const handleChange = (newValue: number, key: string) => {
    setSelectTabKey(key)
    setValue(newValue);
    // TODO: CategoryテーブルのIDを送るべき
    onChange(newValue);
  };

  const iconStyle = (tabNumber: number) => {
    const isSelected = value === tabNumber
    return {
      ...styles.tabIcon,
      borderWidth: isSelected ? 2 : 0
    }
  }

  const tabStyle = (tabNumber: number) => {
    const isSelected = value === tabNumber
    return {
      ...styles.tab,
      color: isSelected ? "#4CAF50" : "inherit",
    }
  }

  const playArrowIconStyle = (tabNumber: number) => {
    const isSelected = value === tabNumber
    return isSelected ? styles.playArrowIcon : {display: "none"}
  }

  const description = () => {
    let content;
    switch (selectTabKey) {
      case "Community":
        content = T("tab_component_community_description")
        break;
      case "Event":
        content = T("tab_component_event_description")
        break;
      case "Report":
        content = T("tab_component_report_description")
        break;
      default:
        content = T("tab_component_all_description")
    }
    return content
  }

  return (
    <>
      <div style={styles.tabContainer}>
        {TAB_LIST.map((tab: any, index: number) => (
          <div
            key={tab.key}
            style={tabStyle(index)}
            onClick={() => handleChange(index, tab.key)}
          >
            <img
              style={iconStyle(index)}
              src={tab.icon}
              alt={tab.key}
            />
            <Typography style={styles.tabName}>{tab.name}</Typography>
            <PlayArrowIcon style={playArrowIconStyle(index)} />
          </div>
        ))}
      </div>

      <Box style={styles.tabDesc} >
        <div>
          {description()}
        </div>
      </Box>
    </>
  );
};

const styles = {
  tabContainer: {
    display: "flex",
    gap: "10px",
    justifyContent: "center",
    width: "100%",
    marginTop: "25px"
  },

  tabDesc: {
    padding: "8px",
    backgroundColor: colors.farm_green150,
    borderRadius: "12px",
    marginTop: "-8px",
    fontSize: 14
  },

  tabIcon: {
    height: 62,
    width: 62,
    borderStyle: "solid",
    borderRadius: 62,
  },

  playArrowIcon: {
    transform: "rotate(-90deg)",
    width: "21.3vw",
    color: colors.farm_green150
  },

  tab: {
    width: "21.3vw",
    padding: "8px 0 0",
    textTransform: "none" as const,
    textAlign: "center" as const,
    height: "auto"
  },

  tabName: {
    fontSize: 12,
    marginTop: "10px",
    height: "auto"
  },
}

export default TabComponent;
